import { IconButton } from '../../../lib/button'
import { FaEraser, FaEdit } from 'react-icons/fa'

export const Cols = (onRowClickUpdate, onRowClickedDelete, beslenmeTypes) => {
  const getTypeText = (type) => {
    if (beslenmeTypes && beslenmeTypes.length > 0) {
      var found = beslenmeTypes.find(t => t.value == type)
      return found ? found.text : '-'
    }
    return '-'
  }

  return [
    {
      name: 'Order',
      selector: 'order',
      sortable: true,
      width: '80px',
      cell: row => <div style={{ fontSize: 14, fontWeight: 'bold' }}>{row.order ?? 0}</div>
    },

    {
      name: 'Ad',
      selector: 'title',
      sortable: true,
      cell: row => <div style={{ fontSize: 14 }}>{row.title}</div>
    },

    {
      name: 'Yayın Yeri',
      selector: 'type',
      sortable: true,
      cell: row => <div style={{ fontSize: 12 }}>{getTypeText(row.type)}</div>
    },

    {
      name: '',
      selector: 'update',
      sortable: true,
      width: '90px',
      cell: row => (
        <IconButton
          icon={<FaEdit size={30} />}
          onClick={() => onRowClickUpdate(row.beslenme_id)}
          // disabled={row.users_id < 1000 ? true : false}
        />
      )
    },

    {
      name: '',
      selector: 'delete',
      sortable: true,
      width: '90px',
      cell: row => (
        <IconButton
          icon={<FaEraser size={30} />}
          onClick={() => onRowClickedDelete(row.beslenme_id)}
          // disabled={row.users_id < 1000 ? true : false}
        />
      )
    }
  ]
}
